import { createFeatureSelector, createSelector } from '@ngrx/store'
import { PageState, ThemeState, UserState } from '../states'

export const THEME_REDUCER_NAME = 'themeR'
export const USER_REDUCER_NAME = 'userR'
export const PAGE_REDUCER_NAME = 'pageR'

const getThemeState = createFeatureSelector<ThemeState>(THEME_REDUCER_NAME)
const getUserState = createFeatureSelector<UserState>(USER_REDUCER_NAME)
const getPageState = createFeatureSelector<PageState>(PAGE_REDUCER_NAME)

//! /* ------------ THEME ------------ */
/* ------ Counter ------ */
export const getTheme = createSelector(getThemeState, state => {
  return state.name
})

//! /* ------------ USER ------------ */
/* ------ Username ------ */
export const getUsername = createSelector(getUserState, state => {
  return state.username
})

/* ------ Email ------ */
export const getEmail = createSelector(getUserState, state => {
  return state.email
})

/* ------ Activision Code ------ */
export const getActivisionCode = createSelector(getUserState, state => {
  return state.activisionCode
})

//! /* ------------ Page ------------ */
/* ------ Current Page ------ */
export const getCurrentPage = createSelector(getPageState, state => {
  return state.currentPage
})
